import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t, type IntlService } from 'ember-intl';
import { PhTrendDown, PhTrendUp, PhEquals } from 'ember-phosphor-icons';
import HeroStat from 'tio-employee/components/dashboard-kit/hero-stat';
import {
  PULSE_PERIOD_DAYS,
  type ProgramPulse,
} from 'tio-employee/utils/partner-dashboard/sources/ta-analytics';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** Hero tile: courses submitted in the trailing period, and which way that moved. */
export default class SubmittedPulseWidget extends Component<
  WidgetComponentSignature<ProgramPulse>
> {
  @service declare intl: IntlService;

  get direction() {
    const { submitted, submittedBefore } = this.args.data;
    return submitted > submittedBefore ? 'up' : submitted < submittedBefore ? 'down' : 'same';
  }

  get context() {
    return this.intl.t(`partner_dashboard.pulse.submitted_${this.direction}`, {
      count: this.args.data.submittedBefore,
      days: PULSE_PERIOD_DAYS,
    });
  }

  get contextIcon() {
    return { up: PhTrendUp, down: PhTrendDown, same: PhEquals }[this.direction];
  }

  <template>
    <HeroStat
      @emphasis="metric"
      @label={{t "partner_dashboard.pulse.submitted" days=PULSE_PERIOD_DAYS}}
      @value={{@data.submitted}}
      @context={{this.context}}
      @contextIcon={{this.contextIcon}}
      data-test-partner-dashboard-submitted-pulse
    />
  </template>
}
